export const categoriesQueryKeys = {
  categories: ['categories']
}

export const useCategoriesQuery = () => {
  return useQueryWrapper({
    key: categoriesQueryKeys.categories,
    query: () => categoriesService.getServiceCategories()
  }, [])
}

export const useHashedCategoriesQuery = () => {
  const { data: categories } = useCategoriesQuery()

  return computed(() => {
    if (!categories.value) {
      return {}
    }

    return categories.value.reduce((acc, category) => {
      acc[category.id] = category
      return acc
    }, {} as Record<string, TServiceCategory>)
  })
}
